module.exports = __webpack_public_path__ + "img/m_my.74261654.png";